import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import './FilePicker.scss';
import AttachmentPreview from '../../routes/conversations/components/AttachmentPreview';
import { GeckoToastService, GeckoBtn } from '../../ui';
import { renderError } from 'services/gecko-error';
import useProgressFileUpload from 'components/useProgressFileUpload';
import { useRedux } from 'services/gecko-store/redux';

function FilePicker(props) {
  const fileInput = useRef(null);
  const baseUploadURL = useRedux(
    (state) => state.appState.apiUrl || process.env.REACT_APP_API_URL
  );
  const uploadURL = `${baseUploadURL}/files/upload`;
  const requestHeaders = useRedux((state) => state.appState.defaultHeaders);
  const { isUploading, uploadProgress, startUpload } = useProgressFileUpload({
    uploadURL,
    requestHeaders,
    formDataKey: 'file',
  });

  const removeFile = () => props.onChange('');

  const handleFileInputChange = (event) => {
    removeFile();
    return startUpload([event.target.files[0]])
      .then(JSON.parse)
      .then((file) => props.onChange(file))
      .catch((error) => {
        try {
          renderError(JSON.parse(error));
        } catch (_) {
          const toast = new GeckoToastService();
          toast.error('Failed to upload file');
        }
      });
  };

  return (
    <div className="FilePicker">
      <GeckoBtn
        name="Upload File"
        icon="far fa-cloud-upload"
        handler={() => fileInput.current.click()}
      />
      <input
        type="file"
        disabled={isUploading}
        onChange={handleFileInputChange}
        accept={props.accept}
        ref={fileInput}
      />
      <AttachmentPreview className="FilePicker-attachment" attachment={props.value} />
      <div
        className="FilePicker-remove-link"
        onClick={removeFile}
        style={{ display: props.value ? 'block' : 'none' }}
      >
        Remove file
      </div>
      <div
        className="FilePicker-progress-bar"
        style={{ display: isUploading ? 'block' : 'none' }}
      >
        <div style={{ width: `${uploadProgress}%` }}></div>
      </div>
    </div>
  );
}

FilePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  accept: PropTypes.string,
};

FilePicker.defaultProps = {
  value: '',
  onChange: () => {},
  accept: '',
};

export default FilePicker;
